import moment from "moment";
import { ApiService } from "./api.service";
import { PrimeIcons } from "@primevue/core/api";
import { nextOccurrenceCell } from "../helpers/schedule-column";
export default class InvoiceBuilderService extends ApiService {
  template = "defaultTemplate";
  namespace = "invoice-builder";
  listingRelations = "peopleCount,schedules,nextOccurrence";
  relations =
    "?expand=peopleSimple,files,files.file,files.file.commentsCount,schedules,nextOccurrence";
  icon = "Schedular";
  favicon = "Schedular";
  DOMAIN = 301;
  action = "action";
  enableSchedular = true;
  showLeftBar = false;
  search = true;
  singular = this.terminology.invoiceBuilder.singular;
  plural = this.terminology.invoiceBuilder.plural;
  vowel = this.terminology.invoiceBuilder.vowel;
  name = `${this.vowel} ${this.singular}`;
  Width = 1200;
  gemItems = [
    {
      key: "create",
      label: this.t("addAEntity", { entity: this.singular }),
      icon: PrimeIcons.PLUS_CIRCLE,
    },
    {
      key: "listing",
      label: this.t("allEntity", { entity: this.plural }),
      icon: PrimeIcons.LIST,
    },
  ];
  listMenuItems = [
    {
      key: "edit",
      label: "Edit " + this.name,
      icon: "edit",
    },
  ];
  columns = [
    {
      header: this.t("displayName"),
      icon: "Tag",
      field: "display_name",
    },
    {
      header: this.t("status"),
      icon: "Lightning",
      field: "status",
      template: (data) => {
        return this.parseStatus(data["status"]);
      },
    },
    {
      header: this.t("date"),
      icon: "GreenCalendar",
      field: "date",
      template: (data) => {
        return moment.unix(data.created_at).format("MM/DD/YYYY");
      },
    },
    {
      header: this.t("nextOccurrence"),
      icon: "Repeat",
      field: "nextOccurrence",
      template: (data) => nextOccurrenceCell(data),
    },
  ];
  gemMenuItems = [
    {
      key: "create",
      label: "Adding a new message",
      icon: PrimeIcons.PLUS,
    },
  ];
  getActionMenu(item) {
    let listMenuItems = [
      {
        key: "edit",
        label: "Edit this Message",
        icon: "edit",
      },
      {
        key: "status",
        label: 1 == item.status ? "inactiveThisEntity" : "activeThisEntity",
        icon: 1 == item.status ? "Disable" : "Enabled",
      },
    ];
    return listMenuItems;
  }
  filterItems = [];
  constructor() {
    super("invoice-builders");
  }
}
